import { ReactElement, PropsWithChildren } from "react";
import { FontIconName, Icon } from "client/Components";
import styles from "./AppointmentDetailsRow.module.less";

export type AppointmentDetailsRowProps = {
	icon: FontIconName;
};

export const AppointmentDetailsRow = (props: PropsWithChildren<AppointmentDetailsRowProps>): ReactElement => {
	const {
		icon,
		children
	} = props;

	return (
		<div className={styles.root}>
			<div className={styles.icon}>
				<Icon value={icon} size="large" />
			</div>
			<div className={styles.content}>
				{ children }
			</div>
		</div>
	);
};
AppointmentDetailsRow.displayName = "AppointmentDetailsRow";
